import './file-upload.scss';
import RingButton from '@jetbrains/ring-ui/components/button-ng/button-ng';
import SslSupportService from '../../blocks/ssl-support-service/ssl-support-service';

export default angular.module('installer.file-upload', [RingButton]).
  directive('fileUpload', () => ({
    restrict: 'E',
    template: `
        <rg-button loader="loader">
          <input class="file-upload__input js-file-input" type="file" anchor-id="{{uploadId}}"/>
          {{buttonText}}
        </rg-button>
      `,
    scope: {
      className: '@',
      uploadId: '@',
      buttonText: '@',
      onFileChosen: '&',
      loader: '=?'
    },
    link(scope, iElement, iAttrs) {
      const element = iElement[0];
      const fileInput = element.querySelector('.js-file-input');
      scope.buttonText = iAttrs.buttonText;
      scope.uploadId = iAttrs.uploadId;
      this.sslSupportService = new SslSupportService();

      iElement[0].addEventListener('click', () => {
        if (fileInput.click) {
          fileInput.value = null;
          fileInput.click();
        } else {
          throw new Error('Your browser doesn\'t support HTMLElement.click');
        }
      });

      fileInput.addEventListener('change', () => {
        const reader = new FileReader();

        reader.onload = e => {
          scope.$applyAsync(() => {
            let binary = '';
            const bytes = new Uint8Array(e.target.result);
            const length = bytes.byteLength;
            for (let i = 0; i < length; i++) {
              binary += String.fromCharCode(bytes[i]);
            }
            let file;
            if (scope.uploadId !== 'keyStore') {
              file = binary;
            } else {
              file = btoa(binary);
            }
            const fullPath = fileInput.value;
            const fileContent = {content: file, fullName: fullPath};
            scope.onFileChosen({fileContent});
          });
        };
        reader.readAsArrayBuffer(fileInput.files[0]);
      });
    }
  }));





// WEBPACK FOOTER //
// ./src/blocks/file-upload/file-upload.js